import { render, staticRenderFns } from "./Report-14.vue?vue&type=template&id=494aeb1a&scoped=true"
import script from "./Report-14.vue?vue&type=script&lang=js"
export * from "./Report-14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494aeb1a",
  null
  
)

export default component.exports